module.exports = __webpack_public_path__ + "static/assets/392dd3edd5a80d5d4880f7395484899a.png";